// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Inventory-__Inventory___1CR88"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Inventory.css
// module id = 2377
// module chunks = 0